export default __webpack_public_path__ + "static/media/V410_SOV.6f8f8d34.pdf";